import { useCallback } from 'react';

import { preparationPageManager } from 'manager/preparationPageManager';

import { getDevicesPermissionMap } from 'utils/getDevicesPermissionMap';

/**
 * Хук вернет функцию, определяющая наличие разрешения на использование микрофона
 *
 * Функция вернет *true* если разрешение есть.
 * */
export function useMicrophonePermission() {
    return useCallback(async () => {
        /** Каждую сессию отправляем пользователя на экран подготовки */
        if (!preparationPageManager.isVisited) return false;

        // у пользователя есть разрешение на использование микрофона
        const hasMicrophonePermission = (await getDevicesPermissionMap(['microphone'])).microphone;

        return !!hasMicrophonePermission;
    }, []);
}
